//import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { installGlobalErrorHandlers } from './lib/error-reporter';
import './index.css';
import { installUnloadFetchGuard } from '@resida/shared';

// Full-page navigations cancel in-flight fetches; keep that from surfacing as console errors.
installUnloadFetchGuard();
installGlobalErrorHandlers();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <App />
);
